import { Injectable } from '@angular/core';
import { HttpService } from '../providers/http.service';
import { AppConfig } from '../app/app.config';

@Injectable()
export class AgService {
    constructor(
        private httpService: HttpService) { }

    //跳转ag页面
    //TQQ 2018-01-02
    forwardGame(gameType) {
        var url = AppConfig.GetProdUrl() + "/Ag/ForwardGame?gameType=" + gameType;
        return this.httpService.get(url);
    }

}


// WEBPACK FOOTER //
// ./src/services/ag.service.ts